
@if (showLocalFilter) {
  <mat-form-field class="search-input">
    <input placeholder="Filter"
      matInput
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="applyFilter($event)">
      <mat-chip-grid #chipList>
      </mat-chip-grid>
    </mat-form-field>
  }
  @for (item of searchItems; track item) {
    <mat-chip-option [selectable]="selectable"
      [removable]="removable" (removed)="remove(item)">
      {{item.name}}
      @if (removable) {
        <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-option>
  }
  <div class="example-container">
    <table mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      class="mat-elevation-z8 mat-table-custom" id="chairliftlist">
      @for (item of columnsToDisplay; track item) {
        <ng-container matColumnDef="{{item}}">
          <th mat-header-cell *matHeaderCellDef>
            {{item === 'actions' || item === 'status' || item === 'index' || item === 'arrow' ? '' : item}}
          </th>
          @if (item==='arrow') {
            <td mat-cell *matCellDef="let element"
              (click)="pushPopElement(element)">
              @if (checkExpanded(element)) {
                <span class="material-icons" matTooltip="Collapse">
                  expand_less
                </span>
              } @else {
                <span class="material-icons" matTooltip="More Details">
                  expand_more
                </span>
              }
            </td>
          }
          @if (item === 'index') {
            <td mat-cell *matCellDef="let element; let i = dataIndex">
              <p>{{i+1}}</p>
            </td>
          }
          @if (item==='actions') {
            <td mat-cell *matCellDef="let element">
              @if (!isEditingRow(element,item)) {
                <button mat-icon-button matTooltip="Edit Row"
                  (click)="onRowEditInit(element)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (isEditingRow(element,item)) {
                <button mat-icon-button matTooltip="Cancel Row"
                  (click)="onRowEditCancel(element)">
                  <mat-icon>rotate_left</mat-icon>
                </button>
              }
            </td>
          }
          @if (item!=='actions') {
            <ng-container *matCellDef="let element">
              @switch (getDataType(item)) {
                @case ('boolean') {
                  <td mat-cell>
                      <mat-checkbox (change)="changeElement(element, item, $event.checked)" [checked]="getInput(element,item)" [ngClass]="isEditingRow(element,item) ? 'black' :''" [disabled]="!isEditingRow(element,item)"></mat-checkbox>
                    </td>
                }
                @case ('string') {
                  <td mat-cell>
                    @if (!isEditingRow(element,item)) {
                      <p [innerHTML]="getInput(element,item)"></p>
                    }
                    @if (isEditingRow(element,item)) {
                      <mat-form-field floatLabel="auto">
                        <input matInput [value]="element[item]" [(ngModel)]="element[item]">
                      </mat-form-field>
                    }
                  </td>
                }
                @case ('number') {
                  <td mat-cell>
                    @if (!isEditingRow(element,item)) {
                      <p [innerHTML]="getInput(element,item)"></p>
                    }
                    @if (isEditingRow(element,item)) {
                      <mat-form-field floatLabel="auto">
                        <input matInput type="number" [value]="element[item]" [(ngModel)]="element[item]">
                      </mat-form-field>
                    }
                  </td>
                }
                @case ('date') {
                  <td mat-cell class="datepicker">
                    @if (!isEditingRow(element,item)) {
                      <p [innerHTML]="getInput(element,item) | date:'yyyy-MM-dd HH:mm'"></p>
                    }
                    @if (isEditingRow(element,item)) {
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker"
                          [(ngModel)]="element[item]"
                          (dateChange)= "getDateUTCChange($event, element, item)">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      }
                    </td>
                  }
                }
              </ng-container>
            }
          </ng-container>
        }

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
            @if (element.Details) {
              <div [@detailExpand]="checkExpanded(element) ? 'expanded' : 'collapsed'"
                [class.expandedDetail]="checkExpanded(element)">
                <table mat-table [dataSource]="element.Details" class="mat-subtable-custom" id="chairliftdetails">
                  @for (item of subcolumnsToDisplay; track item) {
                    <ng-container matColumnDef="{{item}}">
                      <th mat-header-cell *matHeaderCellDef>
                        {{item}}
                      </th>
                      <ng-container>
                        <ng-container *matCellDef="let subelement">
                          @switch (getDataType(item)) {
                            @case ('boolean') {
                              <td mat-cell>
                                  <mat-checkbox (change)="changeElement(subelement, item, $event.checked)" [checked]="getInput(subelement,item)" [ngClass]="isEditingRow(element,item) ? 'black' :''" [disabled]="!isEditingRow(element,item)"></mat-checkbox>
                                </td>
                            }
                            @case ('string') {
                              <td mat-cell>
                                @if (!isEditingRow(element, item)) {
                                  <p [innerHTML]="getInput(subelement,item)"></p>
                                }
                                @if (isEditingRow(element,item)) {
                                  <mat-form-field floatLabel="auto">
                                    @if (item === 'MAXSubscriptionlevel') {
                                      <mat-select style="min-width: 150px;" [(ngModel)]="subelement.MAXSubscriptionlevel" (selectionChange)="changeSubsLevel($event, subelement)">
                                        <mat-option value="TierNo">TierNo</mat-option>
                                        <mat-option value="TierA">TierA</mat-option>
                                        <mat-option value="TierB">TierB</mat-option>
                                        <mat-option value="TierC">TierC</mat-option>
                                      </mat-select>
                                    }
                                    @if (item !== 'MAXSubscriptionlevel') {
                                      <input matInput [value]="subelement[item]" [(ngModel)]="subelement[item]">
                                    }
                                  </mat-form-field>
                                }
                              </td>
                            }
                            @case ('number') {
                              <td mat-cell>
                                @if (!isEditingRow(element,item)) {
                                  <p [innerHTML]="getInput(subelement,item)"></p>
                                }
                                @if (isEditingRow(element,item)) {
                                  <mat-form-field floatLabel="auto">
                                    <input matInput type="number" step="0.01" min="0" [value]="subelement[item]" [(ngModel)]="subelement[item]">
                                  </mat-form-field>
                                }
                              </td>
                            }
                            @case ('date') {
                              <td mat-cell class="datepicker">
                                @if (!isEditingRow(element,item)) {
                                  <p [innerHTML]="getInput(subelement,item) | date:'yyyy-MM-dd HH:mm'"></p>
                                }
                                @if (isEditingRow(element,item)) {
                                  <mat-form-field>
                                    <input matInput [matDatepicker]="picker"
                                      [(ngModel)]="subelement[item]"
                                      (dateChange)= "getDateUTCChange($event, subelement, item)">
                                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                      <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                  }
                                </td>
                              }
                            }
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    }
                    <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let i2 = index; columns: subcolumnsToDisplay;"
                      [class.alternative2]="isEditingRow(element,'')"
                    class="subitem"></tr>
                  </table>
                </div>
              }
            </td>
          </ng-container>

          <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
            class="item"
            [class.alternative2]="isEditingRow(element,'')">
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="row-subitem"></tr>
          </table>
        </div>


